import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import dialogBg from './dialogBg.png';

class AgreementDialog extends React.Component {

  static propTypes = {
    protocolUrl: PropTypes.string.isRequired,
    signingAgreement: PropTypes.func.isRequired,
    showAgreement: PropTypes.bool.isRequired,
    style: PropTypes.object,
    title: PropTypes.string,
  };

  static defaultProps = {
    contentScroll: () => {},
    style: {},
    title: '有道精品课售后政策',
  };

  constructor(props) {
    super(props)
    this.contentScroll = this.contentScroll.bind(this)
    this.handleAccess = this.handleAccess.bind(this)
    this.handleReject = this.handleReject.bind(this)
    this.state = {
      isSendLog: false,
      showAgreement: props.showAgreement,
    }
  }

  componentDidMount() {
    if (this.state.showAgreement) {
      window._rlog.push(['_trackEvent', 'NASA_popup_show']); // eslint-disable-line
      document.body.style.overflow = 'hidden'
    }
  }
  handleAccess() {
    const { signingAgreement } = this.props;
    signingAgreement(2);
    this.setState({
      showAgreement: false,
    })
    document.body.style.overflow = ''
    window._rlog.push(['_trackEvent', 'NASA_agree_click']); // eslint-disable-line
  }
  // 拒绝协议
  async handleReject() {
    const { signingAgreement } = this.props;
    await signingAgreement(1);
    window._rlog.push(['_trackEvent', 'NASA_disagree_click']); // eslint-disable-line
    // 关闭当前页面(这也不能关掉页面，只能替换为空白页面)
    window.opener = null;
    window.open('about:blank', '_self', '').close();
  }
  // 监听协议内容滚动发送日志
  contentScroll() {
    const { isSendLog } = this.state
    if (!isSendLog) {
      this.state.isSendLog = true
      window._rlog.push(['_trackEvent', 'NASA_agreement_read']) // eslint-disable-line
    }
  }

  render() {
    const { style, title, protocolUrl } = this.props
    if (this.state.showAgreement) {
      return (
        <div className={s.dialog} style={style}>
          <div className={s.dialogContent}>
            <img className={s.bgImage} src={dialogBg} alt="" />
            <div className={s.header}>
              <h1>协议条款更新</h1>
            </div>
            <article onScroll={this.contentScroll}>
              <iframe
                title={title}
                src={protocolUrl}
                frameBorder="0"
              />
              <div className={s.layermask} />
            </article>
            <div className={s.footer}>
              <button onClick={() => this.handleAccess()}>我已阅读并同意</button>
              <a onClick={() => this.handleReject()}>我不同意，退出页面</a>
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}

export default withStyles(s)(AgreementDialog);




// WEBPACK FOOTER //
// ./src/components/p_home/AgreementDialog/index.js